module.exports = __webpack_public_path__ + "img/reporting_posts_date.a7ae40e2.svg";